<td-message
  *ngIf="readOnly"
  #readonlyMessage
  class="pad-sm"
  color="warn"
  label="This form is read-only, no changes will be saved."
>
</td-message>
<!--
  bug 2062 - Submit functionality when user hits Enter button is disabled since it was causing bugs.
  (keydown.enter)="$event.target.tagName == 'TEXTAREA'" disables submit functionality while still keeping it enabled for text areas
-->

<form
  *ngIf="form"
  (keydown.enter)="($event.target.tagName == 'TEXTAREA')"
  [formGroup]="form"
  novalidate
  class="grid-form"
  autocomplete="off"
>
  <mat-card-content>
    <fl-flight-crew
      *ngIf="!formHelper.isSimple"
      [flightCrew]="form.get('flightCrew')"
      (crewSelected)="onCrewSelected($event)"
    ></fl-flight-crew>
    <br />
    <div class="ui-g flight-details">
      <div class="ui-g-12 ui-g-nopad">
        <fieldset>
          <legend>
            Flight Details
            <span *ngIf="flightLog.flightSummaryId && !formHelper.isSimple"
              >&nbsp;&#8211;&nbsp;{{ flightLog.flightSummaryId }}</span
            >
          </legend>
          <div data-row-span="12">
            <div data-field-span="2" flValidationState="flightType">
              <label>Flight Type</label>
              <mat-select formControlName="flightType">
                <mat-option *ngFor="let flightType of flightTypes" [value]="flightType.value">{{
                  flightType.label
                }}</mat-option>
              </mat-select>
            </div>
            <ng-container *ngIf="!formHelper.isSimple">
              <div
                *ngIf="features.flightTagNumber"
                data-field-span="2"
                flValidationState="flightTagNumber"
              >
                <label>Flight Tag #</label>
                <input type="text" formControlName="flightTagNumber" maxlength="15" />
              </div>
              <div data-field-span="3" flValidationState="baseId">
                <label>Base</label>
                <fl-base-autocomplete [baseId]="baseIdCtrl"></fl-base-autocomplete>
              </div>
              <div data-field-span="3" flValidationState="aircraftId">
                <label>Aircraft</label>
                <fl-aircraft-autocomplete [aircraftId]="aircraftIdCtrl"></fl-aircraft-autocomplete>
              </div>
              <div *ngIf="features.advantages" data-field-span="2">
                <label>Advantages</label>
                <!--
                  TODO: We'd like to move this control to directly bind to the 'approaches' FormArray instead of using ngModel
                -->
                <mat-select
                  multiple
                  [(ngModel)]="selectedAdvantages"
                  [ngModelOptions]="{ standalone: true }"
                  (selectionChange)="updateAdvantages($event)"
                >
                  <mat-option *ngFor="let option of advantageOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
              </div>
            </ng-container>
          </div>
          <div data-row-span="12" *ngIf="isFixedWing$ | async">
            <div data-field-span="1" flValidationState="matowInKg">
              <label>MATOW (kg)</label>
              <input type="number" min="0" step="0.5" formControlName="matowInKg" />
            </div>
            <div data-field-span="1" flValidationState="maxAftCGInInches">
              <label>Max aft CG (in)</label>
              <input type="number" min="0" step="0.5" formControlName="maxAftCGInInches" />
            </div>
            <div data-field-span="1" flValidationState="maxForeCGInInches">
              <label>Max fore CG (in)</label>
              <input type="number" min="0" step="0.5" formControlName="maxForeCGInInches" />
            </div>
          </div>
          <fl-message-box
            [messages]="topLevelValidationErrors$ | async"
            [level]="'error'"
          ></fl-message-box>
          <div data-row-span="12" *ngIf="formHelper.isEntryPerFlight">
            <div data-field-span="3">
              <label>From</label>
              <input type="text" formControlName="fromLocation" />
            </div>
            <div data-field-span="3">
              <label>To</label>
              <input type="text" formControlName="toLocation" />
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <fl-flight-leg
      *ngFor="let entry of form.controls['entries'].controls; let entryIndex = index"
      [entry]="entry"
      [entryIndex]="entryIndex"
      [flightCrew]="formHelper.flightCrew$ | async"
      [toWaypoint]="formHelper.getToWaypointForEntry$(entryIndex) | async"
      (resetLegs)="onLegReset()"
      (delete)="onLegDelete(entryIndex)"
      [fromWaypoint]="formHelper.getFromWaypointForEntry$(entryIndex) | async"
      [formHelper]="formHelper"
    >
    </fl-flight-leg>
    <br />
    <ng-container *ngIf="maintenanceSummaryType$ | async; let msType">
      <ng-container *ngIf="msType == 'totals'; else oldMaintenanceSummary">
        <ng-container *ngIf="previousMaintenanceTotals$ | async; let previousMaintenanceTotals">
          <ng-container *ngIf="configurationClass$ | async; let configurationClass">
            <fl-maintenance-summary
              *ngIf="!formHelper.isSimple"
              [isTraining]="formHelper.isTraining$ | async"
              [configurationClass]="configurationClass"
              [maintenanceSummary]="form.get('maintenanceSummary')"
              [previousMaintenanceTotals]="previousMaintenanceTotals"
              [aircraftId]="formHelper.aircraftIdCtrl.value"
              [flightType]="form.get('flightType')?.value"
              [flightLogId]="formHelper.flight.id"
            ></fl-maintenance-summary>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-template #oldMaintenanceSummary>
        <td-message
          *ngIf="features.totalsMaintenanceSummary"
          sublabel="Maintenance parameter totals are only available if departure time is set and if they have been configured prior to the time of this flight. Please contact your aviation or maintenance administrator to configure the maintenance parameter totals for this aircraft to view maintenance parameter totals on forms going forward."
          color="primary"
          icon="info"
        ></td-message>
        <br />
        <fl-maintenance-summary-simple
          *ngIf="!formHelper.isSimple"
          [isTraining]="formHelper.isTraining$ | async"
          [configurationClass]="configurationClass$ | async"
          [maintenanceSummary]="form.get('maintenanceSummary')"
          [flightType]="form.get('flightType')?.value"
          [flightLogId]="formHelper.flight.id"
        ></fl-maintenance-summary-simple>
      </ng-template>
    </ng-container>
    <br />
    <div class="ui-g-12 ui-g-nopad">
      <fieldset>
        <legend>Pilot Comments</legend>
        <div data-row-span="12">
          <div data-field-span="12">
            <label>Comments</label>
            <textarea formControlName="comment" rows="3"></textarea>
          </div>
        </div>
      </fieldset>
    </div>
  </mat-card-content>
</form>

<div class="flight-log-form-actions mat-elevation-z24" fxLayout fxLayoutGap="10px">
  <div fxFlex="initial" fxLayout fxLayoutGap="10px" fxLayoutAlign="start center">
    <ng-container *ngIf="!readOnly">
      <button
        type="button"
        *ngIf="isEdit"
        (click)="complete()"
        color="primary"
        [disabled]="(isDisabled$ | async) || (autosaveTriggered$ | async)"
        mat-raised-button
      >
        Submit Log
      </button>
      <button
        type="button"
        color="primary"
        *ngIf="!isEdit"
        [disabled]="isDisabled$ | async"
        (click)="create()"
        mat-raised-button
      >
        Save Draft
      </button>
    </ng-container>
    <button type="button" (click)="back()" mat-button>Close</button>
  </div>
  <div
    *ngIf="!readOnly"
    fxFlex="nogrow"
    fxLayout
    fxLayoutGap="10px"
    fxLayoutAlign="start center"
    class="save-status"
  >
    <div *ngIf="formHelper.isValid$ | async" class="save-success">
      <span *ngIf="autosaveTriggered$ | async">Saving ...</span>
      <ng-container *ngIf="(autosaveTriggered$ | async) === false">
        <span
          *ngIf="lastSave$ | async as lastSave"
          matTooltip="Last saved {{ lastSave | date: 'full' }} ({{ lastSaveDisplay$ | async }})"
        >
          All changes saved.
        </span>
      </ng-container>
    </div>
    <ng-container *ngIf="allValidationErrors$ | async; let errors">
      <div
        *ngIf="(formHelper.isValid$ | async) === false"
        class="save-error"
        (click)="showValidationErrors(errors)"
      >
        Errors found (Click to review)
      </div>
    </ng-container>
    <ng-container *ngIf="(canSubmitTimes$ | async) === false">
      <td-message
        label="Warning"
        sublabel="All Arrival and Departure Times are required to Submit the Log"
        class="submit-warning"
        icon="warning"
      >
      </td-message>
    </ng-container>
  </div>
</div>

<!-- BELOW IS FOR DEBUGGING IN PRODUCTION, DO NOT DELETE -->
<pre style="display: none">
  Validation Errors:
  {{ validationState$ | async | json }}
</pre>
